import React, { useEffect, useState } from "react";
import { getData } from "../../api/api";
import { useStorage } from "../../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";
import { Pagination } from "antd";

export default function EnrolledCoursesPage() {
  const [user] = useStorage("use", null);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Thêm state cho tổng số phần tử
  const pageSize = 10; // Số phần tử mỗi trang

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    // Chú ý: Nếu API của bạn bắt đầu trang từ 0, giữ nguyên currentPage - 1. Nếu bắt đầu từ 1, dùng currentPage
    getData(
      `/retreats/${user.id}/retreats?pageNumber=${
        currentPage - 1
      }&pageSize=${pageSize}`
    )
      .then((response) => {
        const apiData = response?.data?.data || [];
        const mappedCourses = apiData.map((course) => ({
          id: course.id,
          course: course.name,
          lastAccessed: course.startDate,
          progress: 0,
          image: course.retreatImages[0]?.url || "",
        }));
        setCourses(mappedCourses);
        // Lấy tổng số phần tử từ API để sử dụng trong phân trang
        setTotalItems(response?.data?.pagination?.totalRow || 0);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching courses:", error);
        setLoading(false);
      });
  }, [user, currentPage]); // Thêm currentPage vào dependency array

  return (
    <div className="col-span-3">
      <div className="mb-4 bg-white border border-gray-300 rounded-lg shadow-sm sm:px-6 sm:py-4 mt-2">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Course Enrollment History</h1>
          <div className="space-y-6">
            {loading ? (
              <div className="text-center">Loading courses...</div>
            ) : courses.length > 0 ? (
              courses.map((history) => (
                <div
                  key={history.id}
                  className="bg-white rounded-lg shadow-md overflow-hidden flex"
                >
                  <img
                    src={history.image}
                    alt={history.course}
                    className="w-24 h-24 object-cover"
                  />
                  <div className="p-4 flex-grow">
                    <h3 className="font-bold text-lg mb-2">{history.course}</h3>
                    <p className="text-sm text-gray-600">
                      Last accessed: {history.lastAccessed}
                    </p>
                  </div>
                  <div className="p-4 flex items-center">
                    <button
                      onClick={() => navigate(`/user/course/${history.id}`)}
                      className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600 transition-colors"
                    >
                      Continue Learning
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p>No courses enrolled.</p>
            )}
          </div>
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalItems}
              onChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
